module.exports = __webpack_public_path__ + "img/logo3.75ffe52e.png";